module.exports = __webpack_public_path__ + "static/media/mixkit-alert-alarm-1005.b3eccfe6.wav";